/**
 * Auto-synced from dentrist-app-backend lang responses.php files
 */
export const API_ERROR_TRANSLATIONS = {
  "en": {
    "api.errors.client_settings_no_client_assigned": "No client is assigned to your account.",
    "api.errors.common_validation_error": "Validation failed",
    "api.errors.validation_error": "Validation failed",
    "api.errors.common_invalid_credentials": "Invalid credentials",
    "api.errors.invalid_credentials": "Invalid credentials",
    "api.errors.common_login_success": "Login successful",
    "api.errors.login_success": "Login successful",
    "api.errors.common_logout_success": "Logout successful",
    "api.errors.logout_success": "Logout successful",
    "api.errors.common_locale_updated": "Locale updated",
    "api.errors.locale_updated": "Locale updated",
    "api.errors.common_user_created": "User created",
    "api.errors.user_created": "User created successfully",
    "api.errors.common_user_login_success": "User logged in successfully",
    "api.errors.user_login_success": "User logged in successfully",
    "api.errors.common_user_logout_success": "User logged out successfully",
    "api.errors.user_logout_success": "User logged out successfully",
    "api.errors.common_unauthenticated": "Unauthenticated",
    "api.errors.unauthenticated": "Unauthenticated",
    "api.errors.common_vendor_missing": "User is not associated with any vendor",
    "api.errors.vendor_missing": "User is not associated with any vendor",
    "api.errors.common_vendor_mismatch": "vendor_id header does not match your vendor",
    "api.errors.vendor_mismatch": "vendor_id header does not match your vendor",
    "api.errors.common_backoffice_access_denied": "This account cannot access the backoffice portal.",
    "api.errors.backoffice_access_denied": "This account cannot access the backoffice portal.",
    "api.errors.common_backoffice_token_required": "A valid backoffice session token is required.",
    "api.errors.backoffice_token_required": "A valid backoffice session token is required.",
    "api.errors.common_vendor_portal_only": "This account must sign in through the vendor portal.",
    "api.errors.vendor_portal_only": "This account must sign in through the vendor portal.",
    "api.errors.common_password_reset_link_sent": "If an account exists for that email, a password reset link has been sent.",
    "api.errors.password_reset_link_sent": "If an account exists for that email, a password reset link has been sent.",
    "api.errors.common_password_reset_success": "Your password has been reset. You can now log in.",
    "api.errors.password_reset_success": "Your password has been reset. You can now log in.",
    "api.errors.common_contact_admin_to_reset_password": "If this account has no email, contact your lab administrator to reset your password.",
    "api.errors.contact_admin_to_reset_password": "If this account has no email, contact your lab administrator to reset your password.",
    "api.errors.common_use_email_to_reset_password": "This account has an email address. Use the email form to receive a reset link.",
    "api.errors.use_email_to_reset_password": "This account has an email address. Use the email form to receive a reset link.",
    "api.errors.common_vendor_access_denied": "Backoffice accounts cannot access the vendor API.",
    "api.errors.vendor_access_denied": "Backoffice accounts cannot access the vendor API.",
    "api.errors.common_vendor_token_required": "A valid vendor session token is required.",
    "api.errors.vendor_token_required": "A valid vendor session token is required.",
    "api.errors.common_stats_loaded": "Statistics loaded successfully",
    "api.errors.stats_loaded": "Statistics loaded successfully",
    "api.errors.vendor_list_retrieved": "Vendors retrieved",
    "api.errors.vendor_created": "Vendor created",
    "api.errors.vendor_not_found": "Vendor not found",
    "api.errors.vendor_retrieved": "Vendor retrieved",
    "api.errors.vendor_updated": "Vendor updated",
    "api.errors.vendor_deleted": "Vendor deleted",
    "api.errors.subscription_created": "Subscription request submitted successfully.",
    "api.errors.subscription_list_retrieved": "Subscription plans retrieved successfully.",
    "api.errors.subscription_subscriptions_list_retrieved": "Subscriptions retrieved successfully.",
    "api.errors.subscription_plan_retrieved": "Subscription plan retrieved successfully.",
    "api.errors.subscription_plan_updated": "Subscription plan updated successfully.",
    "api.errors.subscription_plan_not_found": "Subscription plan not found.",
    "api.errors.subscription_plan_activated": "Subscription plan activated successfully.",
    "api.errors.subscription_plan_deactivated": "Subscription plan deactivated successfully.",
    "api.errors.subscription_not_found": "Subscription not found.",
    "api.errors.subscription_activated": "Subscription activated successfully. Vendor created and invitation email queued.",
    "api.errors.subscription_already_active": "This subscription is already active.",
    "api.errors.subscription_missing_signup_data": "Subscription is missing vendor or admin signup data.",
    "api.errors.subscription_admin_email_taken": "A user with this admin email already exists.",
    "api.errors.subscription_admin_type_missing": "Vendor admin user type is not configured.",
    "api.errors.subscription_activation_failed": "Failed to activate subscription.",
    "api.errors.page_created": "Page created",
    "api.errors.page_not_found": "Page not found",
    "api.errors.page_updated": "Page updated",
    "api.errors.page_deleted": "Page deleted",
    "api.errors.permission_synced": "Permissions synced successfully",
    "api.errors.permission_assigned": "Permission assigned to user",
    "api.errors.permission_revoked": "Permission revoked from user",
    "api.errors.permission_user_retrieved": "User permissions retrieved",
    "api.errors.permission_all_retrieved": "Permissions retrieved",
    "api.errors.expense_type_list_retrieved": "Expense types retrieved",
    "api.errors.expense_type_created": "Expense type created",
    "api.errors.expense_type_not_found": "Expense type not found",
    "api.errors.expense_type_retrieved": "Expense type retrieved",
    "api.errors.expense_type_updated": "Expense type updated",
    "api.errors.expense_type_deleted": "Expense type deleted",
    "api.errors.unit_list_retrieved": "Units retrieved",
    "api.errors.unit_created": "Unit created",
    "api.errors.unit_not_found": "Unit not found",
    "api.errors.unit_retrieved": "Unit retrieved",
    "api.errors.unit_updated": "Unit updated",
    "api.errors.unit_deleted": "Unit deleted",
    "api.errors.color_list_retrieved": "Colors retrieved",
    "api.errors.color_created": "Color created",
    "api.errors.color_not_found": "Color not found",
    "api.errors.color_retrieved": "Color retrieved",
    "api.errors.color_updated": "Color updated",
    "api.errors.color_deleted": "Color deleted",
    "api.errors.color_delete_blocked": "This color cannot be deleted because it is assigned to one or more formulas.",
    "api.errors.role_list_retrieved": "Roles retrieved",
    "api.errors.role_created": "Role created",
    "api.errors.role_retrieved": "Role retrieved",
    "api.errors.role_updated": "Role updated",
    "api.errors.role_deleted": "Role deleted",
    "api.errors.user_list_retrieved": "Users retrieved",
    "api.errors.user_not_found": "User not found",
    "api.errors.user_retrieved": "User retrieved",
    "api.errors.user_updated": "User updated",
    "api.errors.user_cannot_delete_self": "You cannot delete yourself",
    "api.errors.user_deleted": "User deleted successfully",
    "api.errors.user_types_retrieved": "User types retrieved",
    "api.errors.user_already_verified": "User is already verified",
    "api.errors.user_invitation_expired": "Invitation has expired",
    "api.errors.user_no_invitation_token": "No invitation token found for this user",
    "api.errors.user_invitation_token_requires_regeneration": "Invitation token must be regenerated",
    "api.errors.user_invitation_link_retrieved": "Invitation link retrieved successfully",
    "api.errors.user_invitation_token_regenerated": "Invitation token regenerated successfully",
    "api.errors.user_invitation_sent": "Invitation email sent successfully",
    "api.errors.user_invitation_queued": "Invitation email has been queued for delivery",
    "api.errors.user_invitation_email_failed": "Could not send invitation email. Check mail configuration and try again.",
    "api.errors.user_email_required_for_invitation": "This user has no email address, so an invitation cannot be sent.",
    "api.errors.user_invalid_token": "Invalid invitation token",
    "api.errors.user_invitation_valid": "Invitation token is valid",
    "api.errors.user_invitation_completed": "Account setup completed successfully",
    "api.errors.user_delete_blocked": "This user cannot be deleted because it is associated with existing records.",
    "api.errors.user_client_required_for_dentist": "Dentist users must be assigned to a client.",
    "api.errors.user_cannot_reset_own_password": "You cannot reset your own password this way. Use the profile page or ask another admin.",
    "api.errors.user_temporary_password_reset": "Password was reset to the temporary password. Share it with the user so they can log in and change it.",
    "api.errors.asset_list_retrieved": "Assets retrieved",
    "api.errors.asset_created": "Asset created",
    "api.errors.asset_not_found": "Asset not found",
    "api.errors.asset_retrieved": "Asset retrieved",
    "api.errors.asset_updated": "Asset updated",
    "api.errors.asset_deleted": "Asset deleted",
    "api.errors.transaction_list_retrieved": "Transactions retrieved",
    "api.errors.transaction_created": "Transaction created",
    "api.errors.transaction_not_found": "Transaction not found",
    "api.errors.transaction_retrieved": "Transaction retrieved",
    "api.errors.transaction_updated": "Transaction updated",
    "api.errors.transaction_deleted": "Transaction deleted",
    "api.errors.branch_list_retrieved": "Branches retrieved",
    "api.errors.branch_created": "Branch created",
    "api.errors.branch_not_found": "Branch not found",
    "api.errors.branch_retrieved": "Branch retrieved",
    "api.errors.branch_updated": "Branch updated",
    "api.errors.branch_deleted": "Branch deleted",
    "api.errors.client_list_retrieved": "Clients retrieved",
    "api.errors.client_created": "Client created",
    "api.errors.client_not_found": "Client not found",
    "api.errors.client_retrieved": "Client retrieved",
    "api.errors.client_updated": "Client updated",
    "api.errors.client_deleted": "Client deleted",
    "api.errors.client_delete_blocked": "This client cannot be deleted because it is associated with one or more delivery centers.",
    "api.errors.delivery_center_list_retrieved": "Delivery centers retrieved",
    "api.errors.delivery_center_created": "Delivery center created",
    "api.errors.delivery_center_not_found": "Delivery center not found",
    "api.errors.delivery_center_retrieved": "Delivery center retrieved",
    "api.errors.delivery_center_updated": "Delivery center updated",
    "api.errors.delivery_center_deleted": "Delivery center deleted",
    "api.errors.invoice_list_retrieved": "Invoices retrieved",
    "api.errors.invoice_created": "Invoice created",
    "api.errors.invoice_not_found": "Invoice not found",
    "api.errors.invoice_retrieved": "Invoice retrieved",
    "api.errors.invoice_updated": "Invoice updated",
    "api.errors.invoice_marked_paid": "Invoice marked as paid",
    "api.errors.invoice_canceled": "Invoice canceled",
    "api.errors.invoice_cannot_cancel_paid": "Cannot cancel a paid invoice",
    "api.errors.invoice_cannot_delete_paid": "Paid invoices cannot be deleted",
    "api.errors.invoice_deleted": "Invoice deleted",
    "api.errors.setting_list_retrieved": "Settings retrieved",
    "api.errors.setting_created": "Setting created",
    "api.errors.setting_not_found": "Setting not found",
    "api.errors.setting_retrieved": "Setting retrieved",
    "api.errors.setting_updated": "Setting updated",
    "api.errors.setting_deleted": "Setting deleted",
    "api.errors.order_list_retrieved": "Orders retrieved",
    "api.errors.order_restored": "Order restored",
    "api.errors.order_cancelled": "Order cancelled",
    "api.errors.order_invalid_for_invoice": "One or more orders cannot be attached to invoice due to status",
    "api.errors.order_created": "Order created",
    "api.errors.order_not_found": "Order not found",
    "api.errors.order_retrieved": "Order retrieved",
    "api.errors.order_updated": "Order updated",
    "api.errors.order_status_changed": "Order status changed",
    "api.errors.order_technician_assigned": "Technician assigned to order",
    "api.errors.order_deleted": "Order deleted",
    "api.errors.order_formulas_detached": "Formulas removed from the order successfully",
    "api.errors.formula_type_list_retrieved": "Formula types retrieved",
    "api.errors.formula_type_created": "Formula type created",
    "api.errors.formula_type_not_found": "Formula type not found",
    "api.errors.formula_type_retrieved": "Formula type retrieved",
    "api.errors.formula_type_updated": "Formula type updated",
    "api.errors.formula_type_delete_blocked": "Formula type cannot be deleted because it is in use",
    "api.errors.formula_type_delete_failed": "Failed to delete formula type",
    "api.errors.formula_type_deleted": "Formula type deleted",
    "api.errors.formula_type_restore_not_found": "Formula type to restore not found",
    "api.errors.formula_type_restored": "Formula type restored",
    "api.errors.formula_type_attachment_deleted": "Attachment deleted",
    "api.errors.formula_type_attachment_not_found": "Attachment not found",
    "api.errors.expense_list_retrieved": "Expenses retrieved",
    "api.errors.expense_created": "Expense created",
    "api.errors.expense_not_found": "Expense not found",
    "api.errors.expense_retrieved": "Expense retrieved",
    "api.errors.expense_updated": "Expense updated",
    "api.errors.expense_deleted": "Expense deleted",
    "api.errors.common_success": "Operation completed successfully",
    "api.errors.success": "Operation completed successfully",
    "api.errors.common_profile_updated": "Profile updated",
    "api.errors.profile_updated": "Profile updated",
    "api.errors.common_payload_too_large": "The uploaded file is too large. Please use files up to 20 MB.",
    "api.errors.common_invalid_current_password": "Current password is invalid",
    "api.errors.invalid_current_password": "Current password is invalid",
    "api.errors.common_password_updated": "Password updated",
    "api.errors.password_updated": "Password updated",
    "api.errors.permission_denied": "You do not have permission to perform this action",
    "api.errors.user_type_not_found": "User type not found",
    "api.errors.order_attachment_deleted": "Attachment deleted",
    "api.errors.order_attachment_not_found": "Attachment not found",
    "api.errors.order_courier_assigned": "Courier assigned to order",
    "api.errors.order_cannot_update_paid_invoice": "This order belongs to a paid invoice and cannot be updated. Refund the invoice first.",
    "api.errors.order_cannot_edit_status": "Orders that are finished or delivered cannot be edited.",
    "api.errors.order_cannot_edit_has_invoice": "Orders attached to an invoice cannot be edited.",
    "api.errors.order_cannot_edit_billable_status": "This order has reached the status at which its amount is counted, so its details cannot be edited.",
    "api.errors.order_cannot_change_operational_fields": "Technician, courier, and status cannot be changed while the order is cancelled, in dispute, or on hold.",
    "api.errors.order_cannot_delete_paid_invoice": "Cannot delete an order that is attached to a paid invoice.",
    "api.errors.invoice_refunded": "Invoice refunded and credited to client wallet",
    "api.errors.invoice_mark_paid_undone": "Invoice payment undone; invoice restored to unpaid",
    "api.errors.invoice_cannot_update_paid": "Paid invoices cannot be updated. Undo the payment or refund the invoice first.",
    "api.errors.invoice_whatsapp_ready": "Invoice ready to send via WhatsApp",
    "api.errors.invoice_email_sent": "Invoice sent via email",
    "api.errors.invoice_email_queued": "Invoice email has been queued for delivery",
    "api.errors.money_transfer_channel_list_retrieved": "Money transfer channels retrieved",
    "api.errors.money_transfer_channel_created": "Money transfer channel created",
    "api.errors.money_transfer_channel_retrieved": "Money transfer channel retrieved",
    "api.errors.money_transfer_channel_updated": "Money transfer channel updated",
    "api.errors.money_transfer_channel_deleted": "Money transfer channel deleted",
    "api.errors.money_transfer_channel_not_found": "Money transfer channel not found",
    "api.errors.payment_method_list_retrieved": "Payment methods retrieved",
    "api.errors.payment_method_created": "Payment method created",
    "api.errors.payment_method_retrieved": "Payment method retrieved",
    "api.errors.payment_method_updated": "Payment method updated",
    "api.errors.payment_method_deleted": "Payment method deleted",
    "api.errors.payment_method_not_found": "Payment method not found",
    "api.errors.page_retrieved": "Page retrieved",
    "api.errors.wallet_list_retrieved": "Wallets retrieved",
    "api.errors.wallet_retrieved": "Wallet retrieved",
    "api.errors.wallet_not_found": "Wallet not found"
  },
  "ar": {
    "api.errors.client_settings_no_client_assigned": "لا يوجد عميل مرتبط بحسابك.",
    "api.errors.common_validation_error": "فشلت عملية التحقق من الحقول",
    "api.errors.validation_error": "فشلت عملية التحقق من الحقول",
    "api.errors.common_invalid_credentials": "بيانات اعتماد غير صحيحة",
    "api.errors.invalid_credentials": "بيانات اعتماد غير صحيحة",
    "api.errors.common_login_success": "تم تسجيل الدخول بنجاح",
    "api.errors.login_success": "تم تسجيل الدخول بنجاح",
    "api.errors.common_logout_success": "تم تسجيل الخروج بنجاح",
    "api.errors.logout_success": "تم تسجيل الخروج بنجاح",
    "api.errors.common_locale_updated": "تم تحديث اللغة",
    "api.errors.locale_updated": "تم تحديث اللغة",
    "api.errors.common_user_created": "تم إنشاء المستخدم",
    "api.errors.user_created": "تم إنشاء المستخدم بنجاح",
    "api.errors.common_user_login_success": "تم تسجيل دخول المستخدم بنجاح",
    "api.errors.user_login_success": "تم تسجيل دخول المستخدم بنجاح",
    "api.errors.common_user_logout_success": "تم تسجيل خروج المستخدم بنجاح",
    "api.errors.user_logout_success": "تم تسجيل خروج المستخدم بنجاح",
    "api.errors.common_unauthenticated": "غير مصرح لك",
    "api.errors.unauthenticated": "غير مصرح لك",
    "api.errors.common_vendor_missing": "المستخدم غير مرتبط بأي معمل",
    "api.errors.vendor_missing": "المستخدم غير مرتبط بأي معمل",
    "api.errors.common_vendor_mismatch": "معرّف المعمل في الترويسة لا يطابق المعمل الخاص بك",
    "api.errors.vendor_mismatch": "معرّف المعمل في الترويسة لا يطابق المعمل الخاص بك",
    "api.errors.common_backoffice_access_denied": "لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.",
    "api.errors.backoffice_access_denied": "لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.",
    "api.errors.common_backoffice_token_required": "مطلوب رمز جلسة صالح لصفحة دخول الإدارة.",
    "api.errors.backoffice_token_required": "مطلوب رمز جلسة صالح لصفحة دخول الإدارة.",
    "api.errors.common_vendor_portal_only": "يجب تسجيل الدخول عبرصفحة دخول المعمل.",
    "api.errors.vendor_portal_only": "يجب تسجيل الدخول عبرصفحة دخول المعمل.",
    "api.errors.common_password_reset_link_sent": "إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.",
    "api.errors.password_reset_link_sent": "إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.",
    "api.errors.common_password_reset_success": "تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.",
    "api.errors.password_reset_success": "تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.",
    "api.errors.common_contact_admin_to_reset_password": "إذا لم يكن لهذا الحساب بريد إلكتروني، تواصل مع مدير المعمل لإعادة تعيين كلمة المرور.",
    "api.errors.contact_admin_to_reset_password": "إذا لم يكن لهذا الحساب بريد إلكتروني، تواصل مع مدير المعمل لإعادة تعيين كلمة المرور.",
    "api.errors.common_use_email_to_reset_password": "هذا الحساب مرتبط ببريد إلكتروني. استخدم نموذج البريد لإرسال رابط إعادة التعيين.",
    "api.errors.use_email_to_reset_password": "هذا الحساب مرتبط ببريد إلكتروني. استخدم نموذج البريد لإرسال رابط إعادة التعيين.",
    "api.errors.common_vendor_access_denied": "حسابات الإدارة لا يمكنها الوصول إلى واجهة المعمل.",
    "api.errors.vendor_access_denied": "حسابات الإدارة لا يمكنها الوصول إلى واجهة المعمل.",
    "api.errors.common_vendor_token_required": "مطلوب رمز جلسة صالح لصفحة دخول المعمل.",
    "api.errors.vendor_token_required": "مطلوب رمز جلسة صالح لصفحة دخول المعمل.",
    "api.errors.common_stats_loaded": "تم تحميل الإحصائيات بنجاح",
    "api.errors.stats_loaded": "تم تحميل الإحصائيات بنجاح",
    "api.errors.vendor_list_retrieved": "تم استرجاع التركات التجارية",
    "api.errors.vendor_created": "تم إنشاء التركة التجارية",
    "api.errors.vendor_not_found": "التركة التجارية غير موجودة",
    "api.errors.vendor_retrieved": "تم استرجاع التركة التجارية",
    "api.errors.vendor_updated": "تم تحديث التركة التجارية",
    "api.errors.vendor_deleted": "تم حذف التركة التجارية",
    "api.errors.subscription_created": "تم إرسال طلب الاشتراك بنجاح.",
    "api.errors.subscription_list_retrieved": "تم جلب خطط الاشتراك بنجاح.",
    "api.errors.subscription_subscriptions_list_retrieved": "تم جلب الاشتراكات بنجاح.",
    "api.errors.subscription_plan_retrieved": "تم جلب خطة الاشتراك بنجاح.",
    "api.errors.subscription_plan_updated": "تم تحديث خطة الاشتراك بنجاح.",
    "api.errors.subscription_plan_not_found": "خطة الاشتراك غير موجودة.",
    "api.errors.subscription_plan_activated": "تم تفعيل خطة الاشتراك بنجاح.",
    "api.errors.subscription_plan_deactivated": "تم إلغاء تفعيل خطة الاشتراك بنجاح.",
    "api.errors.subscription_not_found": "الاشتراك غير موجود.",
    "api.errors.subscription_activated": "تم تفعيل الاشتراك بنجاح. تم إنشاء المعمل وجدولة بريد الدعوة.",
    "api.errors.subscription_already_active": "هذا الاشتراك مفعّل بالفعل.",
    "api.errors.subscription_missing_signup_data": "بيانات المعمل أو المسؤول ناقصة في طلب الاشتراك.",
    "api.errors.subscription_admin_email_taken": "يوجد مستخدم بهذا البريد الإلكتروني بالفعل.",
    "api.errors.subscription_admin_type_missing": "نوع مستخدم مسؤول المعمل غير مُعد.",
    "api.errors.subscription_activation_failed": "فشل تفعيل الاشتراك.",
    "api.errors.page_created": "تم إنشاء الصفحة",
    "api.errors.page_not_found": "الصفحة غير موجودة",
    "api.errors.page_updated": "تم تحديث الصفحة",
    "api.errors.page_deleted": "تم حذف الصفحة",
    "api.errors.permission_synced": "تم مزامنة الصلاحيات بنجاح",
    "api.errors.permission_assigned": "تم منح الصلاحية للمستخدم",
    "api.errors.permission_revoked": "تم إلغاء صلاحية من المستخدم",
    "api.errors.permission_user_retrieved": "تم استرجاع صلاحيات المستخدم",
    "api.errors.permission_all_retrieved": "تم استرجاع الصلاحيات",
    "api.errors.expense_type_list_retrieved": "تم استرجاع أنواع المصروفات",
    "api.errors.expense_type_created": "تم إنشاء نوع المصروف",
    "api.errors.expense_type_not_found": "نوع المصروف غير موجود",
    "api.errors.expense_type_retrieved": "تم استرجاع نوع المصروف",
    "api.errors.expense_type_updated": "تم تحديث نوع المصروف",
    "api.errors.expense_type_deleted": "تم حذف نوع المصروف",
    "api.errors.unit_list_retrieved": "تم استرجاع الوحدات",
    "api.errors.unit_created": "تم إنشاء الوحدة",
    "api.errors.unit_not_found": "الوحدة غير موجودة",
    "api.errors.unit_retrieved": "تم استرجاع الوحدة",
    "api.errors.unit_updated": "تم تحديث الوحدة",
    "api.errors.unit_deleted": "تم حذف الوحدة",
    "api.errors.color_list_retrieved": "تم استرجاع الألوان",
    "api.errors.color_created": "تم إنشاء اللون",
    "api.errors.color_not_found": "اللون غير موجود",
    "api.errors.color_retrieved": "تم استرجاع اللون",
    "api.errors.color_updated": "تم تحديث اللون",
    "api.errors.color_deleted": "تم حذف اللون",
    "api.errors.color_delete_blocked": "لا يمكن حذف هذا اللون لأنه مُعيَّن لصيغة واحدة أو أكثر.",
    "api.errors.role_list_retrieved": "تم استرجاع الصلاحيات",
    "api.errors.role_created": "تم إنشاء الصلاحية",
    "api.errors.role_retrieved": "تم استرجاع الصلاحية",
    "api.errors.role_updated": "تم تحديث الصلاحية",
    "api.errors.role_deleted": "تم حذف الصلاحية",
    "api.errors.user_list_retrieved": "تم استرجاع المستخدمين",
    "api.errors.user_not_found": "المستخدم غير موجود",
    "api.errors.user_retrieved": "تم استرجاع المستخدم",
    "api.errors.user_updated": "تم تحديث المستخدم",
    "api.errors.user_cannot_delete_self": "لا يمكنك حذف نفسك",
    "api.errors.user_deleted": "تم حذف المستخدم بنجاح",
    "api.errors.user_types_retrieved": "تم استرجاع أنواع المستخدمين",
    "api.errors.user_already_verified": "المستخدم مفعّل بالفعل",
    "api.errors.user_invitation_expired": "انتهت صلاحية الدعوة",
    "api.errors.user_no_invitation_token": "لا يوجد رمز دعوة لهذا المستخدم",
    "api.errors.user_invitation_token_requires_regeneration": "يجب إعادة إنشاء رمز الدعوة",
    "api.errors.user_invitation_link_retrieved": "تم جلب رابط الدعوة بنجاح",
    "api.errors.user_invitation_token_regenerated": "تم إعادة إنشاء رمز الدعوة بنجاح",
    "api.errors.user_invitation_sent": "تم إرسال بريد الدعوة بنجاح",
    "api.errors.user_invitation_queued": "تمت جدولة بريد الدعوة للإرسال",
    "api.errors.user_invitation_email_failed": "تعذر إرسال بريد الدعوة. تحقق من إعدادات البريد وحاول مرة أخرى.",
    "api.errors.user_email_required_for_invitation": "هذا المستخدم ليس لديه بريد إلكتروني، لذلك لا يمكن إرسال دعوة.",
    "api.errors.user_invalid_token": "رمز الدعوة غير صالح",
    "api.errors.user_invitation_valid": "رمز الدعوة صالح",
    "api.errors.user_invitation_completed": "تم إكمال إعداد الحساب بنجاح",
    "api.errors.user_delete_blocked": "لا يمكن حذف هذا المستخدم لأنه مرتبط بسجلات أخرى.",
    "api.errors.user_client_required_for_dentist": "يجب ربط حساب الطبيب بعميل.",
    "api.errors.user_cannot_reset_own_password": "لا يمكنك إعادة تعيين كلمة مرورك بهذه الطريقة. استخدم صفحة الملف الشخصي أو اطلب من مدير آخر.",
    "api.errors.user_temporary_password_reset": "تم إعادة تعيين كلمة المرور إلى الكلمة المؤقتة. شاركها مع المستخدم ليسجّل الدخول ثم يغيّرها.",
    "api.errors.asset_list_retrieved": "تم استرجاع الأصول",
    "api.errors.asset_created": "تم إنشاء الأصل",
    "api.errors.asset_not_found": "الأصل غير موجود",
    "api.errors.asset_retrieved": "تم استرجاع الأصل",
    "api.errors.asset_updated": "تم تحديث الأصل",
    "api.errors.asset_deleted": "تم حذف الأصل",
    "api.errors.transaction_list_retrieved": "تم استرجاع الحركات المالية",
    "api.errors.transaction_created": "تم إنشاء الحركة المالية",
    "api.errors.transaction_not_found": "الحركة المالية غير موجودة",
    "api.errors.transaction_retrieved": "تم استرجاع الحركة المالية",
    "api.errors.transaction_updated": "تم تحديث الحركة المالية",
    "api.errors.transaction_deleted": "تم حذف الحركة المالية",
    "api.errors.branch_list_retrieved": "تم استرجاع الفروع",
    "api.errors.branch_created": "تم إنشاء الفرع",
    "api.errors.branch_not_found": "الفرع غير موجود",
    "api.errors.branch_retrieved": "تم استرجاع الفرع",
    "api.errors.branch_updated": "تم تحديث الفرع",
    "api.errors.branch_deleted": "تم حذف الفرع",
    "api.errors.client_list_retrieved": "تم استرجاع العملاء",
    "api.errors.client_created": "تم إنشاء العميل",
    "api.errors.client_not_found": "العميل غير موجود",
    "api.errors.client_retrieved": "تم استرجاع العميل",
    "api.errors.client_updated": "تم تحديث العميل",
    "api.errors.client_deleted": "تم حذف العميل",
    "api.errors.client_delete_blocked": "لا يمكن حذف هذا العميل لأنه مرتبط بمركز توصيل أو أكثر.",
    "api.errors.delivery_center_list_retrieved": "تم استرجاع مراكز التوصيل",
    "api.errors.delivery_center_created": "تم إنشاء مركز توصيل",
    "api.errors.delivery_center_not_found": "مركز التوصيل غير موجود",
    "api.errors.delivery_center_retrieved": "تم استرجاع مركز التوصيل",
    "api.errors.delivery_center_updated": "تم تحديث مركز التوصيل",
    "api.errors.delivery_center_deleted": "تم حذف مركز التوصيل",
    "api.errors.invoice_list_retrieved": "تم استرجاع الفواتير",
    "api.errors.invoice_created": "تم إنشاء الفاتورة",
    "api.errors.invoice_not_found": "الفاتورة غير موجودة",
    "api.errors.invoice_retrieved": "تم استرجاع الفاتورة",
    "api.errors.invoice_updated": "تم تحديث الفاتورة",
    "api.errors.invoice_marked_paid": "تم تمييز الفاتورة على أنها مدفوعة",
    "api.errors.invoice_canceled": "تم إلغاء الفاتورة",
    "api.errors.invoice_cannot_cancel_paid": "لا يمكن إلغاء فاتورة مدفوعة",
    "api.errors.invoice_cannot_delete_paid": "لا يمكن حذف فاتورة مدفوعة",
    "api.errors.invoice_deleted": "تم حذف الفاتورة",
    "api.errors.setting_list_retrieved": "تم استرجاع الإعدادات",
    "api.errors.setting_created": "تم إنشاء الإعداد",
    "api.errors.setting_not_found": "الإعداد غير موجود",
    "api.errors.setting_retrieved": "تم استرجاع الإعداد",
    "api.errors.setting_updated": "تم تحديث الإعداد",
    "api.errors.setting_deleted": "تم حذف الإعداد",
    "api.errors.order_list_retrieved": "تم استرجاع الطلبات",
    "api.errors.order_restored": "تم استعادة الطلب",
    "api.errors.order_cancelled": "تم إلغاء الطلب",
    "api.errors.order_invalid_for_invoice": "لا يمكن إرفاق واحد أو أكثر من الطلبات بالفاتورة بسبب الحالة",
    "api.errors.order_created": "تم إنشاء الطلب",
    "api.errors.order_not_found": "الطلب غير موجود",
    "api.errors.order_retrieved": "تم استرجاع الطلب",
    "api.errors.order_updated": "تم تحديث الطلب",
    "api.errors.order_status_changed": "تم تغيير حالة الطلب",
    "api.errors.order_technician_assigned": "تم تعيين الفني للطلب",
    "api.errors.order_deleted": "تم حذف الطلب",
    "api.errors.order_formulas_detached": "تمت إزالة الصيغ من الطلب بنجاح",
    "api.errors.formula_type_list_retrieved": "تم استرجاع أنواع التركيبات",
    "api.errors.formula_type_created": "تم إنشاء نوع التركيبة",
    "api.errors.formula_type_not_found": "نوع التركيبة غير موجود",
    "api.errors.formula_type_retrieved": "تم استرجاع نوع التركيبة",
    "api.errors.formula_type_updated": "تم تحديث نوع التركيبة",
    "api.errors.formula_type_delete_blocked": "لا يمكن حذف نوع التركيبة لأنه قيد الاستخدام",
    "api.errors.formula_type_delete_failed": "فشل حذف نوع التركيبة",
    "api.errors.formula_type_deleted": "تم حذف نوع التركيبة",
    "api.errors.formula_type_restore_not_found": "نوع التركيبة المراد استعادته غير موجود",
    "api.errors.formula_type_restored": "تم استعادة نوع التركيبة",
    "api.errors.formula_type_attachment_deleted": "تم حذف المرفق",
    "api.errors.formula_type_attachment_not_found": "المرفق غير موجود",
    "api.errors.expense_list_retrieved": "تم استرجاع المصروفات",
    "api.errors.expense_created": "تم إنشاء المصروف",
    "api.errors.expense_not_found": "المصروف غير موجود",
    "api.errors.expense_retrieved": "تم استرجاع المصروف",
    "api.errors.expense_updated": "تم تحديث المصروف",
    "api.errors.expense_deleted": "تم حذف المصروف",
    "api.errors.common_success": "تمت العملية بنجاح",
    "api.errors.success": "تمت العملية بنجاح",
    "api.errors.common_profile_updated": "تم تحديث الملف الشخصي",
    "api.errors.profile_updated": "تم تحديث الملف الشخصي",
    "api.errors.common_payload_too_large": "الملف المرفوع كبير جدًا. يرجى استخدام ملفات بحجم 20 ميجابايت كحد أقصى.",
    "api.errors.common_invalid_current_password": "كلمة المرور الحالية غير صحيحة",
    "api.errors.invalid_current_password": "كلمة المرور الحالية غير صحيحة",
    "api.errors.common_password_updated": "تم تحديث كلمة المرور",
    "api.errors.password_updated": "تم تحديث كلمة المرور",
    "api.errors.permission_denied": "ليس لديك صلاحية القيام بهذا الإجراء",
    "api.errors.user_type_not_found": "نوع المستخدم غير موجود",
    "api.errors.order_attachment_deleted": "تم حذف المرفق",
    "api.errors.order_attachment_not_found": "المرفق غير موجود",
    "api.errors.order_courier_assigned": "تم تعيين المندوب للطلب",
    "api.errors.order_cannot_update_paid_invoice": "هذا الطلب مرتبط بفاتورة مدفوعة ولا يمكن تعديله. قم باسترداد الفاتورة أولاً.",
    "api.errors.order_cannot_edit_status": "لا يمكن تعديل الطلبات المكتملة أو المسلّمة.",
    "api.errors.order_cannot_edit_has_invoice": "لا يمكن تعديل الطلبات المرتبطة بفاتورة.",
    "api.errors.order_cannot_edit_billable_status": "وصل هذا الطلب إلى الحالة التي يُحتسب عندها مبلغه، لذا لا يمكن تعديل تفاصيله.",
    "api.errors.order_cannot_change_operational_fields": "لا يمكن تغيير الفني أو المندوب أو الحالة بينما الطلب ملغى أو في نزاع أو معلّق.",
    "api.errors.order_cannot_delete_paid_invoice": "لا يمكن حذف طلب مرتبط بفاتورة مدفوعة.",
    "api.errors.invoice_refunded": "تم استرداد الفاتورة وإضافة المبلغ إلى محفظة العميل",
    "api.errors.invoice_mark_paid_undone": "تم التراجع عن تسجيل الدفع وإعادة الفاتورة إلى غير مدفوعة",
    "api.errors.invoice_cannot_update_paid": "لا يمكن تعديل الفواتير المدفوعة. قم بالتراجع عن الدفع أو استرداد الفاتورة أولاً.",
    "api.errors.invoice_whatsapp_ready": "الفاتورة جاهزة للإرسال عبر واتساب",
    "api.errors.invoice_email_sent": "تم إرسال الفاتورة عبر البريد الإلكتروني",
    "api.errors.invoice_email_queued": "تمت جدولة إرسال الفاتورة عبر البريد الإلكتروني",
    "api.errors.money_transfer_channel_list_retrieved": "تم استرجاع قنوات التحويل",
    "api.errors.money_transfer_channel_created": "تم إنشاء قناة تحويل",
    "api.errors.money_transfer_channel_retrieved": "تم استرجاع قناة التحويل",
    "api.errors.money_transfer_channel_updated": "تم تحديث قناة التحويل",
    "api.errors.money_transfer_channel_deleted": "تم حذف قناة التحويل",
    "api.errors.money_transfer_channel_not_found": "قناة التحويل غير موجودة",
    "api.errors.payment_method_list_retrieved": "تم استرجاع طرق الدفع",
    "api.errors.payment_method_created": "تم إنشاء طريقة دفع",
    "api.errors.payment_method_retrieved": "تم استرجاع طريقة الدفع",
    "api.errors.payment_method_updated": "تم تحديث طريقة الدفع",
    "api.errors.payment_method_deleted": "تم حذف طريقة الدفع",
    "api.errors.payment_method_not_found": "طريقة الدفع غير موجودة",
    "api.errors.page_retrieved": "تم استرجاع الصفحة",
    "api.errors.wallet_list_retrieved": "تم استرجاع المحافظ",
    "api.errors.wallet_retrieved": "تم استرجاع المحفظة",
    "api.errors.wallet_not_found": "المحفظة غير موجودة",
    "api.errors.request_failed": "حدث خطأ ما"
  }
};
